export const formatNotificationMessage = (text, splitSymbol) => {
  if (!(splitSymbol && text)) return '';
  const tooltipTextSplitted = text?.split(splitSymbol) || [];
  return (
    <p>
      <label>{tooltipTextSplitted?.[0]}</label>
      <ul>
        {tooltipTextSplitted?.slice(1)?.map((p, index) => (
          <li key={`${p[0]}_${++index}`}>{p}</li>
        ))}
      </ul>
    </p>
  );
};
